__turbopack_context__.v({
  "root": "Media-module__Uy8aYG__root",
});
